<template>
    <div>
        <GridPage
            :form-default="{
            }"
            :filters-default="{
            }"
            :filter-items="[
            ]"
            filters-q-placeholder="名前"
            form-modal-id="inventory"
            search-action="inventory/index"
            :hide-header="true"
            >
            <template v-slot:form="{ form, init }">
                <Inventory :model="form" :init="init"></Inventory>
            </template>

            <template v-slot:column="{ item }">
<b-col>
                <div class="d-flex flex-wrap bd-highlight">
                    <div class="p-2 flex-shrink-1 bd-highlight">
                        <ItemThumb :model="item" class="mb-1" />
                    </div>
                    <div class="p-2 flex-grow-1 bd-highlight">

<b-row class="no-gutters">
                <b-col md="6" class="align-self-center">
<!--
                    <ItemBadges :model="item" class="mb-1" />
-->
    
                    <p class="mb-1 font-weight-bold">
                        {{ item.name }}
                    </p>

<!--
                    <div class="mb-1">
                        {{ item.price | baseNumberFormatter }}
                        <template v-if="item.price2"> - {{ item.price2 | baseNumberFormatter }}</template>
                    </div>
-->
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <InventoryInfo :model="item" />
                </b-col>
</b-row>

                    </div>
                </div>
</b-col>
            </template>
        </GridPage>
<!--
        <b-link :href="`/f/${auth_uuid}/`" target="_blank">
            公開ページを表示する
            <font-awesome-icon class="fa-fw" icon="external-link-alt" />
        </b-link>
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Inventory from '@/components/Inventory.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import InventoryInfo from '@/components/InventoryInfo.vue'

export default {
    components: {
        GridPage,
        Inventory,
        ItemBadges,
        ItemThumb,
        InventoryInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
    },
}
</script>

